// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyBVJQ1F-gIhmYywUEr_u7IL646isu_eXxI",
    authDomain: "tatwaee-22084.firebaseapp.com",
    projectId: "tatwaee-22084",
    messagingSenderId: "768667767692",
    appId: "1:768667767692:web:f2c6ece5d841088c057ca9",
    measurementId: "G-K8G7Q21NB2",
    vapidKey: "BIrSaR9KftBSKeuRC3E6crCrdS_ig_gnXX_683o9cAZDwpuRqKvumxLRmcNiidybeAy6soQZnj929cEO0Y_Bdqg"
  },
  apiUrl: 'http://tatawoey.waleedalenazi.com:80/parse/functions/',
  testUrl: 'https://localhost:44362/api/'
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
